<template>
  <div>
    <!-- Snackbar（初回表示のみ） -->
    <v-snackbar
      v-if="!closed && snackbar"
      class="mt-16"
      text
      :color="color"
      v-model="snackbar"
      top
      timeout="-1"
    >
      {{ message }}
      <template v-if="close" v-slot:action="{ attrs }">
        <v-icon v-bind="attrs" @click="hide">mdi-close-circle</v-icon>
      </template>
    </v-snackbar>

    <!-- 再表示用Snackbar（右下） -->
    <v-snackbar
      v-else
      text
      v-model="closed"
      :color="color"
      timeout="-1"
      bottom
      right
      width="370"
      :class="['snack-re', { expanded: reopenPanel }]"
    >
      <div class="snack-content">
        <v-icon :color="color" class="mr-5" @click="toggleReopenPanel">
          {{ color === 'snack_warning' ? 'mdi-alert-circle' : 'mdi-information' }}
        </v-icon>
        <span class="message-text">{{ message }}</span>
        <v-icon class="expand-icon" @click="toggleReopenPanel">
          mdi-chevron-right
        </v-icon>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: {
    disp: {
      type: Boolean,
      default: false,
    },
    message: String,
    close: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      snackbar: false,
      closed: false,            // 初期表示用SnackBarの状態
      reopenPanel: false,       // 再表示用SnackBarの展開状態
    };
  },

  watch: {
    disp(value) {
      this.snackbar = value;
      if (value) {
        this.closed = false;
        this.reopenPanel = false;
      }
    },
  },

  methods: {
    hide() {
      this.snackbar = false;
      this.closed = true;
      this.reopenPanel = false;
    },
    toggleReopenPanel() {
      this.reopenPanel = !this.reopenPanel;
    },
  },
};
</script>

<style scoped>
/** SnackBar */
.v-snack {
  opacity: 0.9;
}

/** 再表示用SnackBar */
.snack-re >>> .v-snack__wrapper {
  transform: translateX(88%); /* 初期：チラ見せ */
  transition: transform 0.3s ease;
}
.snack-re.expanded >>> .v-snack__wrapper {
  transform: translateX(0); /* 展開時：全表示 */
}

.snack-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.message-text {
  flex: 1;
}

</style>
